<!-- <app-modal-title [title]="title"></app-modal-title>
<mat-dialog-content class="mat-typography">

    <app-title title="{{ 'VisualCompFormPage.About' | translate }}"></app-title>

    <div class="icon-avatar">
        <div class="img">
            <img src="{{visual.icon}}" onError="this.src ='../../../assets/images/chart.jpeg'"
                (click)="photoUpload.click()" />
        </div>
        <input hidden type="file" #photoUpload (change)="uploadIconImage($event)" />
    </div>

    <form [formGroup]="pageForm">
        <mat-form-field>
            <mat-label>{{ 'VisualCompFormPage.Name' | translate }}</mat-label>
            <input matInput [(ngModel)]="visual.name" formControlName="name" required>
        </mat-form-field>
        <br>
    </form>

    <mat-form-field>
        <mat-label>{{ 'VisualCompFormPage.Description' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="visual.description"></textarea>
    </mat-form-field>
    <br>

    <mat-form-field>
        <mat-label>{{ 'VisualCompFormPage.CompStatus' | translate }}</mat-label>
        <mat-select [(value)]="visual.access">
            <mat-option [value]="1">Public</mat-option>
            <mat-option [value]="0">Private</mat-option>
        </mat-select>
    </mat-form-field>
    <br>

    <mat-form-field *ngIf="!isCreateForm">
        <mat-label>{{ 'VisualCompFormPage.Version' | translate }}</mat-label>
        <input matInput [(ngModel)]="visual.version" disabled>
    </mat-form-field>
    <br>

    <mat-form-field *ngIf="!isCreateForm">
        <mat-label>{{ 'VisualCompFormPage.CreatedBy' | translate }}</mat-label>
        <input matInput [(ngModel)]="visual.createdby" disabled>
    </mat-form-field>
    <br>

    <mat-form-field *ngIf="!isCreateForm">
        <mat-label>{{ 'VisualCompFormPage.UpdatedBy' | translate }}</mat-label>
        <input matInput [(ngModel)]="visual.updatedby" disabled>
    </mat-form-field>
    <br>

    <mat-form-field *ngIf="!isCreateForm">
        <mat-label>{{ 'VisualCompFormPage.UpdateTime' | translate }}</mat-label>
        <input matInput value="{{visual.updateDate}}" disabled>
    </mat-form-field>
    <br>

    <app-title title="{{ 'Common.Code' | translate }}" buttonTitle="{{ 'Common.ShowBiggerEditor' | translate }}" (btnEvent)="openBiggerEditor()"></app-title>
    <div style="height: 500px">
        <ngx-monaco-editor style="height: 500px" [options]="editorOptions" [(ngModel)]="visual.code" (onInit)="editorInit($event)">
        </ngx-monaco-editor>
    </div>


    <app-title title="{{ 'VisualCompFormPage.Libraries' | translate }}"></app-title>
    <mat-selection-list [(ngModel)]="selectedLibraries" [compareWith]="compareFunctionForLibraries">
        <mat-list-option *ngFor="let dashboard of libraries" [value]="dashboard.widgetLibraryId">
            {{dashboard.name}}
        </mat-list-option>
    </mat-selection-list>
    <br>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button class="b-btn" mat-dialog-close>{{ 'Common.Cancel' | translate }}</button>
    <button mat-button class="b-btn b-success" cdkFocusInitial *ngIf="!isCreateForm"
        (click)="upsertVisualComponent()">{{ 'Common.Update' | translate }}</button>
    <button mat-button class="b-btn b-success" cdkFocusInitial *ngIf="isCreateForm"
        (click)="upsertVisualComponent()">{{ 'Common.Create' | translate }}</button>
</mat-dialog-actions> -->
<!-- TitleUpdate -->
<app-custom-modal [title]="title" [subtitle]="'VisualCompFormPage.SubText'" img="/assets/images/visual-component.png">
    <div body style="padding: 0px 20px;overflow: auto;max-height: 100%;height: 100%;">
        <mat-stepper class="no-box-shadow" [linear]="true" #stepper>
            <mat-step [stepControl]="pageForm" label="{{ 'VisualCompFormPage.About' | translate }}">
                <div style="display: flex;">
                    <div class="icon-avatar" style="width: 40%;">
                        <div class="img">
                            <img src="{{visual.icon}}" onError="this.src ='../../../assets/images/chart.jpeg'"
                                (click)="photoUpload.click()" />
                        </div>
                        <input hidden type="file" #photoUpload (change)="uploadIconImage($event)" />
                    </div>
                    <div style="width: 60%;">

                        <form [formGroup]="pageForm">
                            <mat-form-field>
                                <mat-label>{{ 'VisualCompFormPage.Name' | translate }}</mat-label>
                                <input matInput [(ngModel)]="visual.name" formControlName="name" required>
                            </mat-form-field>
                            <br>
                        </form>

                        <mat-form-field>
                            <mat-label>{{ 'VisualCompFormPage.Description' | translate }}</mat-label>
                            <textarea matInput [(ngModel)]="visual.description"></textarea>
                        </mat-form-field>
                        <br>

                        <mat-form-field>
                            <mat-label>{{ 'VisualCompFormPage.CompStatus' | translate }}</mat-label>
                            <mat-select [(value)]="visual.access">
                                <mat-option [value]="1">Public</mat-option>
                                <mat-option [value]="0">Private</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <br>
                    </div>
                </div>
                <div style="display: flex;">
                    <mat-form-field *ngIf="!isCreateForm">
                        <mat-label>{{ 'VisualCompFormPage.Version' | translate }}</mat-label>
                        <input matInput [(ngModel)]="visual.version" disabled>
                    </mat-form-field>
                    <br>

                    <mat-form-field *ngIf="!isCreateForm">
                        <mat-label>{{ 'VisualCompFormPage.CreatedBy' | translate }}</mat-label>
                        <input matInput [(ngModel)]="visual.createdby" disabled>
                    </mat-form-field>
                    <br>

                    <mat-form-field *ngIf="!isCreateForm">
                        <mat-label>{{ 'VisualCompFormPage.UpdatedBy' | translate }}</mat-label>
                        <input matInput [(ngModel)]="visual.updatedby" disabled>
                    </mat-form-field>
                    <br>

                    <mat-form-field *ngIf="!isCreateForm">
                        <mat-label>{{ 'VisualCompFormPage.UpdateTime' | translate }}</mat-label>
                        <input matInput value="{{visual.updateDate}}" disabled>
                    </mat-form-field>
                    <br>
                </div>
                <div>
                    <app-title title="{{ 'VisualCompFormPage.Libraries' | translate }}"></app-title>
                    <app-custom-dropdown-menu-with-search [multipleSelection]="libraryDropdownSettings.multipleSelection"
                        [initialData]="{selection:visual.widgetLibraries}" [menudata]="librarForDropdownMenu"
                        [dropDownSettings]="libraryDropdownSettings"
                        (selectElement)="selectLibrary($event)"></app-custom-dropdown-menu-with-search>
                </div>
            </mat-step>
            <mat-step [label]="'VisualCompFormPage.Config'|translate">
                <!-- <app-title title="Config" (btnEvent)="configFormVisible=true" (btnEvent2)="configFormVisible=false"
                    [buttonTitle]="'configForm'" [buttonTitle2]="'configList'"></app-title> -->
                <form *ngIf="configFormVisible" [formGroup]="configForm" style="display: flex;flex-direction: column;">
                    <div style="display:flex ;align-items: center;justify-content: end;">
                        <button class="button add-button" mat-button (click)="changeFormVisible()">
                            <mat-icon>list</mat-icon>
                        </button>
                    </div>

                    <div>
                        <div class="config-form-area">
                            <mat-form-field>
                                <mat-label>{{ 'VisualCompFormPage.ConfigName' | translate }}</mat-label>
                                <input matInput formControlName="name">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>{{ 'VisualCompFormPage.VisibleName' | translate }}</mat-label>
                                <input matInput formControlName="visibleName">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>{{ 'VisualCompFormPage.Type' | translate }}</mat-label>
                                <mat-select matInput formControlName="type">
                                    <mat-option *ngFor="let item of configType" [value]="item">{{item}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>{{ 'VisualCompFormPage.Value' | translate }}</mat-label>
                                <input matInput formControlName="value"
                                    [type]="configForm.value.type=='Boolean'?'text': configForm.value.type?.toLowerCase()">
                            </mat-form-field>
                            <mat-form-field style="flex-basis: 100%;">
                                <mat-label>{{ 'VisualCompFormPage.Description' | translate }}</mat-label>
                                <textarea matInput formControlName="description"></textarea>
                            </mat-form-field>
                            <div style="display: flex;align-items: center; flex-basis: 100%;"
                                *ngIf="configForm.value.type!=='Boolean'">
                                <mat-slide-toggle (change)="changeToggle($event.checked)"
                                    [checked]="addMultipleValue">Çoklu
                                    Seçim</mat-slide-toggle>
                            </div>
                            <form [formGroup]="configSelectionForm" *ngIf="addMultipleValue"
                                style="width: 100%;display: flex;flex-wrap: wrap;">
                                <div *ngFor="let item of selectionList"
                                    style="flex-basis: 45%;margin-right: 10px;display: flex;align-items: center;">
                                    <mat-form-field style="flex-basis: 100%;">
                                        <label>{{ 'VisualCompFormPage.SelectionValue' | translate }}</label>
                                        <input [type]="configForm.value.type?.toLowerCase()" matInput
                                            class="custom-gray-input" [formControlName]="item.id">
                                    </mat-form-field>
                                    <mat-icon (click)="deleteSelectionElement(item)"
                                        style="margin-left: 10px;">delete</mat-icon>
                                </div>
                                <div style="display: flex;align-items: center;justify-content: end; margin-top: 10px;">
                                    <button (click)="addSelectionElement()" mat-stroked-button
                                        class="custom-primary-stroked-button">
                                        <mat-icon style="transform: scale(0.8);">add</mat-icon>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div style="display: flex;align-items: center;justify-content: end;">
                            <button (click)="addConfigToList()" mat-stroked-button
                                class="custom-primary-stroked-button">
                                {{configFormType=='add' ?('Common.Add' | translate):('Common.Update' | translate) }}
                            </button>
                        </div>

                    </div>
                </form>
                <div *ngIf="!configFormVisible">
                    <div style="display:flex ;align-items: center;justify-content: end;margin-bottom: 5px;">
                        <button class="button add-button" mat-button (click)="changeFormVisible()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <app-data-list (changedSort)="changedSort($event)" [dragConfig]="true" [itemsPerPage]="this.visual.config.length" *ngIf="this.visual.config.length>0" (dataFunction)="actionButtonsClick($event)"
                        [columns]="displayedColumns" [datas]="this.visual.config"></app-data-list>
                    <div *ngIf="this.visual.config.length<=0"
                        style="text-align: center;width: 100%;height: 100%;color:rgb(134,153,217);font-weight: bold;font-size: 1rem;box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);min-height: 30vh;display: flex;align-items: center;justify-content: center;flex-direction: column;">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100"
                            viewBox="0,0,256,256">
                            <g fill="#5e6da6" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                style="mix-blend-mode: normal">
                                <g transform="scale(5.12,5.12)">
                                    <path
                                        d="M32.21875,2.0625l-0.78125,0.3125l-2.8125,1.09375l-0.78125,0.3125l0.1875,0.8125l0.59375,3c-0.29297,0.29297 -0.60547,0.63672 -0.9375,1l-2.96875,-0.65625l-0.8125,-0.1875l-0.3125,0.75l-1.21875,2.8125l-0.3125,0.75l0.6875,0.46875l2.5625,1.71875c-0.03125,0.48828 -0.02734,0.98047 0,1.46875l-2.625,1.625l-0.71875,0.4375l0.3125,0.78125l1.09375,2.8125l0.3125,0.78125l0.8125,-0.1875l3,-0.59375c0.30469,0.36328 0.64063,0.69141 1,1l-0.6875,3l-0.1875,0.8125l0.78125,0.34375l2.8125,1.1875l0.75,0.3125l0.46875,-0.6875l1.71875,-2.5625c0.48828,0.03125 0.98047,0.02734 1.46875,0l1.625,2.65625l0.4375,0.6875l0.78125,-0.28125l3.59375,-1.4375l-0.1875,-0.8125l-0.6875,-3.28125c0.375,-0.31641 0.71484,-0.65625 1.03125,-1.03125l3.03125,0.78125l0.84375,0.21875l0.3125,-0.78125l1.21875,-2.8125l0.34375,-0.78125l-0.75,-0.46875l-2.625,-1.59375c0.03125,-0.48828 0.02734,-0.98047 0,-1.46875l2.625,-1.625l0.71875,-0.4375l-0.3125,-0.78125l-1.09375,-2.8125l-0.3125,-0.78125l-0.84375,0.1875l-3.0625,0.6875c-0.30469,-0.36328 -0.64062,-0.69141 -1,-1l0.65625,-3l0.1875,-0.8125l-0.75,-0.3125l-2.8125,-1.21875l-0.78125,-0.3125l-0.46875,0.71875l-1.59375,2.53125c-0.46094,-0.04687 -0.96094,-0.00391 -1.46875,0.03125l-1.625,-2.65625zM31.375,4.53125l1.46875,2.40625l0.375,0.59375l0.6875,-0.15625c0.70703,-0.15625 1.375,-0.07031 2.28125,0.03125l0.625,0.0625l0.34375,-0.53125l1.4375,-2.28125l1.25,0.53125l-0.625,2.6875l-0.15625,0.65625l0.5625,0.375c0.61328,0.4375 1.125,0.94922 1.5625,1.5625l0.375,0.5625l0.65625,-0.15625l2.75,-0.625l0.5,1.25l-2.40625,1.4375l-0.53125,0.34375l0.0625,0.625c0.09375,0.83594 0.09375,1.53906 0,2.375l-0.0625,0.625l0.53125,0.34375l2.375,1.46875l-0.5,1.1875l-2.78125,-0.6875l-0.6875,-0.15625l-0.375,0.5625c-0.4375,0.61328 -0.94922,1.125 -1.5625,1.5625l-0.53125,0.375l0.125,0.65625l0.625,2.96875l-1.25,0.46875l-1.4375,-2.375l-0.34375,-0.53125l-0.625,0.0625c-0.83594,0.09375 -1.53906,0.09375 -2.375,0l-0.625,-0.0625l-0.3125,0.5l-1.53125,2.3125l-1.28125,-0.5625l0.59375,-2.6875l0.15625,-0.625l-0.53125,-0.40625c-0.61328,-0.4375 -1.125,-0.94922 -1.5625,-1.5625l-0.375,-0.53125l-0.65625,0.125l-2.6875,0.5625l-0.46875,-1.25l2.375,-1.46875l0.5625,-0.34375l-0.09375,-0.625c-0.09375,-0.83594 -0.09375,-1.53906 0,-2.375l0.09375,-0.59375l-0.53125,-0.34375l-2.3125,-1.53125l0.53125,-1.28125l2.71875,0.625l0.59375,0.125l0.375,-0.46875c0.57031,-0.66406 1.15625,-1.25 1.65625,-1.75l0.375,-0.375l-0.09375,-0.5l-0.5625,-2.6875zM35,10c-2.75,0 -5,2.25 -5,5c0,2.75 2.25,5 5,5c2.75,0 5,-2.25 5,-5c0,-2.75 -2.25,-5 -5,-5zM35,12c1.66797,0 3,1.33203 3,3c0,1.66797 -1.33203,3 -3,3c-1.66797,0 -3,-1.33203 -3,-3c0,-1.66797 1.33203,-3 3,-3zM13.53125,20l-0.125,0.84375l-0.5,3.25c-0.54297,0.17188 -1.06641,0.42188 -1.5625,0.6875l-3.4375,-2.5l-3.5,3.5l0.46875,0.6875l1.90625,2.75c-0.26953,0.53516 -0.50781,1.07031 -0.6875,1.59375l-3.28125,0.59375l-0.8125,0.15625v4.875l0.8125,0.15625l3.28125,0.59375c0.17578,0.54688 0.41797,1.05859 0.6875,1.5625l-1.96875,2.65625l-0.53125,0.6875l3.5,3.5l0.6875,-0.46875l2.75,-1.90625c0.53516,0.26953 1.07031,0.50781 1.59375,0.6875l0.5,3.25l0.125,0.84375h4.90625l0.125,-0.8125l0.625,-3.28125c0.54297,-0.17187 1.06641,-0.42187 1.5625,-0.6875l3.4375,2.5l3.5,-3.5l-0.46875,-0.6875l-2,-2.78125c0.26172,-0.52734 0.51172,-1.04687 0.6875,-1.5625l3.375,-0.59375l0.8125,-0.15625v-4.90625l-4.21875,-0.625c-0.17187,-0.53906 -0.39062,-1.06641 -0.65625,-1.5625l2,-2.75l0.46875,-0.6875l-0.5625,-0.59375l-2.3125,-2.40625l-0.59375,-0.625l-0.71875,0.5l-2.75,2c-0.52734,-0.26172 -1.04687,-0.51172 -1.5625,-0.6875l-0.5,-3.25l-0.125,-0.84375zM15.25,22h1.5l0.5625,3.5625l0.5625,0.1875c0.89844,0.30078 1.73828,0.58203 2.40625,1l0.5625,0.34375l0.53125,-0.375l2.5,-1.8125l1.125,1.1875l-1.8125,2.53125l-0.40625,0.53125l0.375,0.5625c0.44922,0.71875 0.80078,1.55078 0.96875,2.3125l0.15625,0.65625l0.65625,0.09375l3.0625,0.46875v1.53125l-3.0625,0.53125l-0.59375,0.09375l-0.1875,0.5625c-0.30078,0.89844 -0.58203,1.73828 -1,2.40625l-0.375,0.5625l0.40625,0.53125l1.8125,2.53125l-1.125,1.09375l-2.5,-1.8125l-0.53125,-0.375l-0.5625,0.34375c-0.71875,0.44922 -1.55078,0.80078 -2.3125,0.96875l-0.625,0.15625l-0.125,0.65625l-0.53125,2.96875h-1.53125l-0.5625,-3.5625l-0.5625,-0.1875c-0.89844,-0.30078 -1.73828,-0.58203 -2.40625,-1l-0.5625,-0.34375l-0.53125,0.375l-2.53125,1.71875l-1.09375,-1.09375l1.78125,-2.40625l0.4375,-0.5625l-0.375,-0.5625c-0.44922,-0.71875 -0.80078,-1.51953 -0.96875,-2.28125l-0.15625,-0.65625l-0.65625,-0.125l-2.96875,-0.53125v-1.5625l2.96875,-0.53125l0.59375,-0.125l0.1875,-0.53125c0.30078,-0.89844 0.58203,-1.73828 1,-2.40625l0.34375,-0.5625l-0.375,-0.53125l-1.71875,-2.53125l1.125,-1.09375l2.5,1.8125l0.53125,0.375l0.5625,-0.34375c0.71875,-0.44922 1.55078,-0.80078 2.3125,-0.96875l0.65625,-0.15625l0.09375,-0.65625zM16,29c-2.74609,0 -5,2.25391 -5,5c0,2.74609 2.25391,5 5,5c2.74609,0 5,-2.25391 5,-5c0,-2.74609 -2.25391,-5 -5,-5zM16,31c1.65625,0 3,1.34375 3,3c0,1.65625 -1.34375,3 -3,3c-1.65625,0 -3,-1.34375 -3,-3c0,-1.65625 1.34375,-3 3,-3z">
                                    </path>
                                </g>
                            </g>
                        </svg>

                        <span> {{"VisualCompFormPage.NoData"|translate}}</span>
                    </div>
                    <!-- <app-data-table (openModal)="configFormVisible=true" [displayedColumns]="displayedColumns"
                        [displayedColumnsName]="displayedColumnsName" [data]="configList"></app-data-table> -->
                </div>
            </mat-step>
            <mat-step label="{{ 'Common.Code' | translate }}">
                <app-title title="{{ 'Common.Code' | translate }}"
                    buttonTitle="{{ 'Common.ShowBiggerEditor' | translate }}"
                    (btnEvent)="openBiggerEditor()"></app-title>
                <div style="height: 500px">
                    <ngx-monaco-editor style="height: 500px" [options]="editorOptions" [(ngModel)]="visual.code"
                        (onInit)="editorInit($event)">
                    </ngx-monaco-editor>
                </div>

            </mat-step>
        </mat-stepper>














        <!-- <app-title title="{{ 'VisualCompFormPage.Libraries' | translate }}"></app-title>
        <mat-selection-list [(ngModel)]="selectedLibraries" [compareWith]="compareFunctionForLibraries">
            <mat-list-option *ngFor="let dashboard of libraries" [value]="dashboard.widgetLibraryId">
                {{dashboard.name}}
            </mat-list-option>
        </mat-selection-list>
        <br> -->
        
    </div>
    <!-- <div footer>
        <mat-dialog-actions align="end">
            <button mat-button class="b-btn" mat-dialog-close>{{ 'Common.Cancel' | translate }}</button>
            <button mat-button class="b-btn b-primary" (click)="changeStep('back')"
                *ngIf="stepper.selectedIndex !== 0">{{
                'Common.Back' | translate }}</button>
            <button mat-button class="b-btn b-success" (click)="changeStep('next')"
                *ngIf="stepper.selectedIndex<steppercount">{{
                'Common.Next' |
                translate }}</button>
            <button mat-button class="b-btn b-success" (click)="upsertVisualComponent()" cdkFocusInitial
                *ngIf="stepper.selectedIndex==steppercount">{{
                'Common.Done' | translate }}</button>
        </mat-dialog-actions>
    </div> -->


</app-custom-modal>
<mat-dialog-actions align="end">
    <button mat-button class="b-btn" mat-dialog-close>{{ 'Common.Cancel' | translate }}</button>
    <button mat-button class="b-btn b-primary" (click)="changeStep('back')"
        *ngIf="stepper.selectedIndex !== 0">{{
        'Common.Back' | translate }}</button>
    <button mat-button class="b-btn b-success" (click)="changeStep('next')"
        *ngIf="stepper.selectedIndex<steppercount">{{
        'Common.Next' |
        translate }}</button>
    <button mat-button class="b-btn b-success" (click)="upsertVisualComponent()" cdkFocusInitial
        *ngIf="stepper.selectedIndex==steppercount">{{
        'Common.Done' | translate }}</button>
</mat-dialog-actions>